/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const CircleHollow = (props) => {
  return (
    <BaseSvgIcon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
      <g stroke="none" fillRule="evenodd">
        <circle id="Oval" cx="10" cy="10" r="3" strokeWidth="1" stroke="#00ADEE" fill="none" />
      </g>
    </BaseSvgIcon>
  )
}

export default CircleHollow
